/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Menu
 * @desc Action Menu for resourceItem
 */

import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { ResourceItemActionDelete } from 'labstep-web/components/ResourceItem/Action/Delete';
import { ResourceItemActionDuplicate } from 'labstep-web/components/ResourceItem/Action/Duplicate';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { IResourceItemActionMenuProps } from './types';

export enum Action {
  duplicate = 'duplicate',
  delete = 'delete',
  assign = 'assign',
}

export const ResourceItemActionMenu: React.FC<
  IResourceItemActionMenuProps
> = ({ resourceItem, type, actions = [] }) => (
  <ActionMenu type={type}>
    {actions.includes(Action.duplicate) && (
      <ResourceItemActionDuplicate resourceItem={resourceItem} />
    )}
    {actions.includes(Action.assign) && (
      <EntityUserActionManage entity={resourceItem} />
    )}
    {actions.includes(Action.delete) && (
      <ResourceItemActionDelete resourceItem={resourceItem} />
    )}
  </ActionMenu>
);

ResourceItemActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
